import { useToken } from "../../common/TokenContext";
import React, { useState } from "react";
import { Link } from 'react-router-dom';
import SyntaxHighlighter from "react-syntax-highlighter";
import ResponseStatusFooter from "../../common/ResponseStatusFooter";
import { defaultStyle } from "react-syntax-highlighter/dist/esm/styles/hljs";
import { EntityServices } from "../../Services/EntityServices";
import { ICredentials, IResponse } from "../../types/types";
import { GetSimpleLanguagesGET } from "../../Services/app_helper";
import ShowSnackbar from "../../Services/snackbar";
import { END_POINTS_PATH } from "../../routes/paths";

interface props {
    codeBlackTitle: string;
}

interface codeBlockProps {
    Language: string;
    code: string;
}

export default function TryGetBalance(props: props) {
    const { token } = useToken();
    const [copy, setCopy] = useState(false);

    const [loadButton, setLoadButton] = useState(false);

    const [url, setUrl] = useState(END_POINTS_PATH.GetBalance.slice(1));

    const tryLanguages = GetSimpleLanguagesGET(END_POINTS_PATH.GetBalance.slice(1));

    const intializeCodeBlockProps: codeBlockProps = {
        Language: "Csharp",
        code: tryLanguages.Csharp,
    };

    const [sampleCode, setCode] = useState(intializeCodeBlockProps);

    const [responseBody, setResponseBody] = useState(null as any);

    const onLangaugeSelected = (language: string) => {
        const tryLanguages = GetSimpleLanguagesGET(url);
        if (language.startsWith("Csharp"))
            setCode({ Language: "Csharp", code: tryLanguages.Csharp });
        else if (language.startsWith("Java"))
            setCode({ Language: "Java", code: tryLanguages.Java });
        else if (language.startsWith("JavaScript"))
            setCode({ Language: "Java", code: tryLanguages.JavaScript });
        else if (language.startsWith("PHP"))
            setCode({ Language: "PHP", code: tryLanguages.PHP });
        else if (language.startsWith("Python"))
            setCode({ Language: "Python", code: tryLanguages.Python });
    };

    const onTry = async () => {
        const service = new EntityServices<String>();
        setLoadButton(true);
        try {
            var response = await service.GetList(
                `${END_POINTS_PATH.GetBalance}`,
                token
            );
            if (response === null) {
                ShowSnackbar("Something went wrong", "danger");
                return;
            }

            if (response?.statusCode === 200) {
                setLoadButton(false);
                setResponseBody(JSON.stringify(response));
                ShowSnackbar("Success", "primary");
            } else {
                setLoadButton(false);
                setResponseBody(JSON.stringify(response));
                ShowSnackbar("Failed", "danger");
            }
        } catch (error) {
            setLoadButton(false);
            ShowSnackbar("Failed", "danger");
        }
    };

    return (
        <>
            <div className="mt-5 me-4">
                <div className="row" style={{ backgroundColor: "#282C34" }}>
                    <div className="d-flex flex-row justify-content-between bg-primary px-5 text-white text-xs py-2">
                        <p className="my-auto">{props.codeBlackTitle}</p>
                        <div className="btn-group mt-2 mb-2">
                            <button
                                type="button"
                                className="btn btn-default dropdown-toggle"
                                data-bs-toggle="dropdown"
                            >
                                Language <span className="caret"></span>
                            </button>
                            <ul className="dropdown-menu" role="menu">
                                <li>
                                    <Link to="#" onClick={() => onLangaugeSelected("Csharp")}>
                                        <i className="fa fa-circle text-success"></i> C#
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#" onClick={() => onLangaugeSelected("Java")}>
                                        <i className="fa fa-circle text-success"></i> Java
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#" onClick={() => onLangaugeSelected("PHP")}>
                                        <i className="fa fa-circle text-success"></i> PHP
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#" onClick={() => onLangaugeSelected("Python")}>
                                        <i className="fa fa-circle text-success"></i> Python
                                    </Link>
                                </li>
                                <li>
                                    <Link to="#" onClick={() => onLangaugeSelected("JavaScript")}>
                                        <i className="fa fa-circle text-success"></i> JavaScript
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <SyntaxHighlighter
                        language={sampleCode.Language}
                        style={defaultStyle}
                        showLineNumbers={true}
                        wrapLongLines={true}
                        customStyle={{
                            paddingTop: "15px",
                            paddingBottom: "15px",
                            fontWeight: 100,
                            fontSize: 12,
                            height: 370,
                            width: "100%",
                        }}
                    >
                        {sampleCode.code}
                    </SyntaxHighlighter>
                    <div className="d-flex flex-row justify-content-end px-5 text-white text-xs pb-2">
                        {!copy ? (
                            <button
                                onClick={() => {
                                    navigator.clipboard.writeText(sampleCode.code);
                                    setCopy(true);
                                    setTimeout(() => {
                                        setCopy(false);
                                    }, 3000);
                                }}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    height={20}
                                    width={22}
                                >
                                    <title>content-paste</title>
                                    <path d="M11.5,1C12.71,1 13.72,1.86 13.95,3H17C18.66,3 20,4.34 20,6V19C20,20.66 18.66,22 17,22H6C4.34,22 3,20.66 3,19V6C3,4.34 4.34,3 6,3H9.05C9.28,1.86 10.29,1 11.5,1M12.91,3C12.71,2.42 12.15,2 11.5,2C10.85,2 10.29,2.42 10.09,3H12.91M6,4C4.9,4 4,4.9 4,6V19C4,20.1 4.9,21 6,21H17C18.1,21 19,20.1 19,19V6C19,4.9 18.1,4 17,4H16V7H7V4H6M8,4V6H15V4H8Z" />
                                </svg>
                                <span className="pl-2 text-white">Copy code</span>
                            </button>
                        ) : (
                            <button>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    height={20}
                                    width={22}
                                >
                                    <title>check</title>
                                    <path d="M18.9,8.1L9,18L4.05,13.05L4.76,12.34L9,16.59L18.19,7.39L18.9,8.1Z" />
                                </svg>
                                <span className="pl-2 text-white">Copy code</span>
                            </button>
                        )}
                    </div>
                </div>
                <div className="row">
                    <div className="card mt-5 shadow-sm border">
                        <div className="card-header border-bottom d-flex flex-row justify-content-between">
                            <div className="card-title">Response</div>
                        </div>
                        <div className="card-body p-3">
                            {responseBody == null ? (
                                <div className="text-start">
                                    Click
                                    <span className="bg-light p-1 rounded-2 bordered">
                                        Try it!
                                    </span>
                                    below to start a request and see the response here!
                                </div>
                            ) : (
                                <pre className="text-start">
                                    {JSON.stringify(JSON.parse(responseBody), null, 2)}
                                </pre>
                            )}
                        </div>
                        <div className="card-footer">
                            <ResponseStatusFooter responseBody={responseBody} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="card mt-5 shadow-sm border">
                    <div className="card-body p-3">
                        <div className="mt-3 text-end">
                            {token ? (
                                <button
                                    className="btn btn-primary"
                                    disabled={loadButton}
                                    onClick={onTry}
                                >
                                    Try it!
                                </button>
                            ) : (
                                <p className="text-warning text-center my-4">
                                    Try to get the token by using <Link to="/getToken" >GetToken</Link> endpoint to
                                    enable the "Try it!" button.
                                </p>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}